import { ArrowLeft, ArrowRight } from "lucide-react"
import ReactPaginate, { ReactPaginateProps } from "react-paginate";
import { twMerge } from "tailwind-merge";

interface ClickEvent {
    index: number | null;
    selected: number;
    nextSelectedPage: number | undefined;
    event: object;
    isPrevious: boolean;
    isNext: boolean;
    isBreak: boolean;
    isActive: boolean;
}

interface IProps extends ReactPaginateProps {
    setCurrPage: (page: number) => void;
    currPage: number;
    activeClassName?: string;
    containerClassName?: string;
    pageLinkClassName?: string;
    pageClassName?: string;
}

export default function Pagination({ setCurrPage, currPage, ...props }: IProps) {
    const handlePageChange = (selectedPage: ClickEvent) => {
        setCurrPage(selectedPage.selected);
    };

    return (
        <ReactPaginate
            // @ts-ignore
            className={twMerge(
                props.className, 
                "flex items-center border border-secondary-100 rounded-lg",
                "text-xs text-secondary font-normal divide-x divide-secondary-100"
            )}
            previousLabel={
                <div className="flex items-center py-2.5 px-4">
                    <ArrowLeft className="size-4 mr-2" />
                    <span>Back</span>
                </div>
            }
            nextLabel={
                <div className="flex items-center py-2.5 px-4">
                    <span>Next</span>
                    <ArrowRight className="size-4 ml-2" />
                </div>
            }
            activeClassName={twMerge(
                "bg-[#EDE8E4] text-primary",
                props.activeClassName
            )}
            pageClassName={twMerge(
                "w-10 py-2.5 text-center",
                props.pageClassName
            )}
            breakClassName={"w-10 py-2.5 text-center"}
            disabledLinkClassName={"opacity-50 cursor-not-allowed"}
            pageLinkClassName={twMerge(
                "",
                props.pageLinkClassName
            )}
            onPageChange={handlePageChange} // handler function
            initialPage={currPage} // current page number
            {...props}
        />
    );
};